module.exports = __webpack_public_path__ + "img/Hong Kong.a09d95d9.svg";